<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-subheader class="primary headline white--text" style="width: 100%">
        {{ $t("navbar.menu.reviews") }} - {{ name }}
      </v-subheader>
      <v-card-text v-if="hasReviews">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"></th>
                <th class="text-left">Name</th>
                <th class="text-left">Rating</th>
                <th class="text-left">Comments</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in reviews" :key="key">
                <td>
                  <v-avatar size="40">
                    <v-img :src="item.image"></v-img>
                  </v-avatar>
                </td>
                <td>{{ item.name }}</td>
                <td>
                  <v-rating color="primary" readonly dense small :value="item.rating"></v-rating>
                </td>
                <td>{{ item.comments }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t("reviews.average") }}</td>
                <td>{{ averageRating }}</td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <div v-else>
        <v-card-title>
          {{ this.$t("reviews.noReviewsTitle") }}
        </v-card-title>
        <v-card-text>
          {{ this.$t("reviews.noReviewsEventText") }}
        </v-card-text>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-show="hasReviews" text color="primary" @click="downloadXLS"
          ><v-icon left>mdi-download</v-icon>Download</v-btn
        >
        <v-btn color="primary" @click="dialog = false">{{ $t("common.close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const Excel = require("exceljs");

export default {
  props: ["name", "ratings"],
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    downloadXLS() {
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet("Feedback");

      worksheet.columns = [
        { header: "Name", key: "name", width: 15 },
        { header: "Rating", key: "rating", width: 8 },
        { header: "Comments", key: "comments", width: 40 },
      ];

      this.reviews.forEach((review) => {
        worksheet.addRow([review.name, `${review.rating}/5`, review.comments || "No Comments"]);
      });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `${this.$props.name} feedback.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    },
    userShortName(id) {
      return this.$store.getters.userShortName(id) ?? "Unknown user";
    },
    getImageUrlById(id) {
      return this.$store.getters.getImageUrlById(id);
    },
  },
  computed: {
    hasReviews() {
      return this.reviews.length > 0;
    },
    reviews() {
      return Object.keys(this.ratings || {})
        .map((userId) => {
          const review = this.ratings[userId];
          return {
            userId,
            name: this.userShortName(userId),
            image: this.$store.getters.getImageUrlById(userId),
            rating: review.rating,
            comments: review.comments,
          };
        })
        .filter((review) => review.rating > 0);
    },
    averageRating() {
      const ratings = Object.values(this.ratings).filter((rating) => rating.rating > 0);

      const total = ratings.reduce((acc, review) => acc + review.rating, 0);
      return (total / ratings.length).toFixed(1);
    },
  },
};
</script>
